// extracted by mini-css-extract-plugin
module.exports = {"createPanel":"CreateMedicationPanel_createPanel__DfUEZ"};